"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactToastify = require("react-toastify");

var _axios = _interopRequireDefault(require("axios"));

var _formik = require("formik");

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _schema = _interopRequireDefault(require("./schema"));

var _defaultTranslations = require("./defaultTranslations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ChangePin = function ChangePin(_ref) {
  var translations = _ref.translations,
      onError = _ref.onError,
      onSuccess = _ref.onSuccess,
      onCancel = _ref.onCancel;

  if (!translations) {
    translations = _defaultTranslations.defaultTranslations;
  }

  var validate = function validate(values) {
    var errors = {};

    if (!/^[0-9]*$/.test(values.oldPin)) {
      errors.oldPin = translations.changePinValidation;
    }

    if (!/^[0-9]*$/.test(values.newPin)) {
      errors.newPin = translations.changePinValidation;
    }

    if (!/^[0-9]*$/.test(values.newPinConfirm)) {
      errors.newPinConfirm = translations.changePinValidation;
    } else if (values.newPin !== values.newPinConfirm) {
      errors.newPinConfirm = translations.changePinDontMatch;
    }

    return errors;
  };

  var onSubmit = function onSubmit(values, _ref2) {
    var setSubmitting = _ref2.setSubmitting;

    _axios.default.put("/auth/pin", {
      old: values.oldPin,
      new: values.newPin
    }).then(function () {
      onSuccess();
      setSubmitting(false);

      _reactToastify.toast.success(translations.changePinSuccess);
    }).catch(function (_ref3) {
      var response = _ref3.response;

      _reactToastify.toast.error(translations.changePinError);

      setSubmitting(false);
      onError(response);
    });
  };

  return /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.Card, null, /*#__PURE__*/_react.default.createElement(_formik.Formik, {
    validationSchema: (0, _schema.default)(translations),
    validate: validate,
    onSubmit: onSubmit,
    initialValues: {
      oldPin: "",
      newPin: "",
      newPinConfirm: ""
    }
  }, function (_ref4) {
    var isSubmitting = _ref4.isSubmitting,
        isValid = _ref4.isValid,
        values = _ref4.values,
        errors = _ref4.errors,
        dirty = _ref4.dirty,
        handleChange = _ref4.handleChange,
        handleBlur = _ref4.handleBlur;
    return /*#__PURE__*/_react.default.createElement(_formik.Form, null, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, {
      isSmall: true
    }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      isError: errors.oldPin,
      onChange: handleChange,
      name: "oldPin",
      type: "password",
      pattern: "[0-9]*",
      inputMode: "numeric",
      placeholder: "".concat(translations.enter, " ").concat(translations.old, " ").concat(translations.pin),
      onBlur: handleBlur,
      value: values.oldPin
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      isVisible: errors.oldPin
    }, errors.oldPin), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, {
      isSmall: true
    }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      isError: errors.newPin,
      onChange: handleChange,
      onBlur: handleBlur,
      name: "newPin",
      type: "password",
      pattern: "[0-9]*",
      inputMode: "numeric",
      placeholder: "".concat(translations.enter, " ").concat(translations.new, " ").concat(translations.pin),
      value: values.newPin
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      isVisible: errors.newPin
    }, errors.newPin), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRow, {
      isSmall: true
    }, /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormTextbox, {
      isError: errors.newPinConfirm,
      onChange: handleChange,
      name: "newPinConfirm",
      type: "password",
      pattern: "[0-9]*",
      inputMode: "numeric",
      placeholder: "".concat(translations.confirm, " ").concat(translations.new, " ").concat(translations.pin),
      onBlur: handleBlur,
      value: values.newPinConfirm
    })), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.FormRowMessage, {
      margin: "0 0 1rem",
      isVisible: errors.newPinConfirm
    }, errors.newPinConfirm), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      type: "submit",
      isLoading: isSubmitting,
      style: {
        marginBottom: "1rem"
      },
      disabled: !isValid || !dirty
    }, translations.changePin), /*#__PURE__*/_react.default.createElement(_fiverReactUiComponents.BlockButton, {
      isDefault: true,
      type: "button",
      onClick: onCancel
    }, translations.cancel));
  }));
};

var _default = ChangePin;
exports.default = _default;